// src/components/Header.js
import React, { useContext, useCallback, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import CartWidget from './CartWidget';
import '../AppContext'; // ensure AppContext is loaded once
import { AppContext } from '../AppContext';
import './Header.css';
import './CoffeeLink.css';

const Header = () => {
  const navigate = useNavigate();
  const { isLoggedIn, setIsLoggedIn, currentUser, setUser, setProfileImage, setCredits } = useContext(AppContext);

  const [mobileOpen, setMobileOpen] = useState(false);
const toggleMobile = () => setMobileOpen(v => {
  const next = !v;
  if (!next) setMarketOpen(false);
  return next;
});
const closeMobile = () => { setMobileOpen(false); setMarketOpen(false); };


  const [isMarketOpen, setMarketOpen] = useState(false);

const handleMarketLink = (site) => {
  const map = {
    spndat: 'https://spndat.com/',
    sfr: 'https://thedatchain.com/',
    streetflavor: 'https://streetflavorrecords.com/',
    youngstruggle: 'https://youngstruggle615.com',
    bypassthemaster: 'https://bypassthemaster.com',
    abizarreworld: 'https://abizarreworld.com',
    dattickets: 'https://dattickets.com',
    thevidbox: 'https://thevidbox.com'
  };
  const url = map[site];
  if (url) window.open(url, '_blank', 'noopener,noreferrer');
  setMarketOpen(false);
  setMobileOpen(false);
};



  const handleLogout = useCallback(async () => {
    try {
      await signOut(getAuth());
    } catch (e) {
      console.error('Sign out error:', e);
    } finally {
      setUser?.(null);
      setProfileImage?.('');
      setCredits?.(0);
      setIsLoggedIn?.(false);
      setMobileOpen(false);
      navigate('/home');
    }
  }, [navigate, setUser, setProfileImage, setCredits, setIsLoggedIn]);

  const ALLOWED_EDITORS = new Set([
    'h0fEIStkM4XHTDErZM5i8XIo9rA3',
    'OHaY20b54nTGd5BBgbJOL2BHEbX2',
    'Mkf4631LCEOYmHXWRzGirPdxBrt1'
  ]);

  return (
    <header className="sf-header">
      {/* logo */}
      <img
        src="/BizarreLogo1.png"
        alt="Street Flavor Records – 34 Years"
        className="header-logo"
        onClick={() => { navigate('/home'); closeMobile(); }}
        style={{ cursor: 'pointer' }}
      />

      {/* hamburger (mobile only) */}
      <button
        className="sf-hamburger-toggle"
        aria-label="Toggle navigation"
        aria-expanded={mobileOpen}
        aria-controls="sf-main-nav"
        onClick={toggleMobile}
      >
        <span className="sf-hamburger-bar"></span>
        <span className="sf-hamburger-bar"></span>
        <span className="sf-hamburger-bar"></span>
      </button>

      {/* nav */}
      <nav id="sf-main-nav" className={`main-nav ${mobileOpen ? 'open' : ''}`}>
<NavLink to="/" className="sf-nav-link" onClick={closeMobile}>HOME</NavLink>
<NavLink to="/about" className="sf-nav-link" onClick={closeMobile}>ABOUT</NavLink>
<NavLink to="/shop" className="sf-nav-link" onClick={closeMobile}>SHOP</NavLink>
        <div className="sf-dropdown">
  <button
    className="sf-dropdown-btn"
    onClick={() => setMarketOpen(v => !v)}
    aria-haspopup="true"
    aria-expanded={isMarketOpen}
  >
    TDC MARKET PLACE
    <span className={`sf-caret ${isMarketOpen ? 'up' : ''}`}></span>
  </button>

  <ul className={`sf-dropdown-menu ${isMarketOpen ? 'open' : ''}`}>
    <li>
      <button className="sf-dropdown-link" onClick={() => handleMarketLink('spndat')}>
        SPNDAT
      </button>
    </li>
    <li>
      <button className="sf-dropdown-link" onClick={() => handleMarketLink('sfr')}>
        THE DAT CHAIN
      </button>
    </li>
        <li>
      <button className="sf-dropdown-link" onClick={() => handleMarketLink('streetflavor')}>
        STREET FLAVOR RECORDS
      </button>
    </li>
    <li>
  <button className="sf-dropdown-link" onClick={() => handleMarketLink('dattickets')}>
    DAT TICKETS
  </button>
</li>
<li>
  <button className="sf-dropdown-link" onClick={() => handleMarketLink('thevidbox')}>
    THE VID BOX
  </button>
</li>
<li>
  <button className="sf-dropdown-link" onClick={() => handleMarketLink('bypassthemaster')}>
    BYPASS THE MASTER
  </button>
</li>
    <li>
  <button className="sf-dropdown-link" onClick={() => handleMarketLink('youngstruggle')}>
    YOUNG STRUGGLE
  </button>
</li>

<li>
  <button className="sf-dropdown-link" onClick={() => handleMarketLink('abizarreworld')}>
    A BIZARRE WORLD
  </button>
</li>


  </ul>
</div>

<NavLink to="/contact" className="sf-nav-link" onClick={closeMobile}>CONTACT</NavLink>
{currentUser && (
  <NavLink to="/wallet" className="sf-nav-link" onClick={closeMobile}>WALLET</NavLink>
)}

{currentUser && (
  ALLOWED_EDITORS.has(currentUser.userId) ? (
    <NavLink to="/release" className="sf-nav-link" onClick={closeMobile}>ADMIN</NavLink>
  ) : (
    <NavLink to="/my-orders" className="sf-nav-link" onClick={closeMobile}>MY ORDERS</NavLink>
  )
)}
{currentUser ? (
  <button className="nav-logout" onClick={handleLogout}>LOGOUT</button>
) : (
  <NavLink to="/login" className="sf-nav-link" onClick={closeMobile}>LOGIN</NavLink>
)}


      </nav>

      {/* socials */}
      <div className="social-links">
        <a href="https://www.facebook.com/BizarreofD12/">Facebook</a>
        <a href="https://x.com/bizarresworld?lang=en">𝕏</a>
        <a href="https://www.instagram.com/bizarresworld/?hl=en">Instagram</a>
        <a href="https://www.youtube.com/channel/UCBEJ4MJYdH26nVyRU3HZXwg">YouTube</a>
      </div>

      {/* widgets inside header */}
      <CartWidget />


      {/* Scoped styles */}
      <style>{`
        :root{
  --sf-gold:#fdca05;
  --sf-gold-20:#fdca05;

  /* Fine-tune hamburger position here */
  --burger-top: 30px;   /* increase to move DOWN */
  --burger-right: 18px; /* increase to move LEFT */

  /* Mobile menu spacing controls */
    --mobile-item-gap: .15rem;
  --mobile-pad-top: .05rem;         /* was ~.95rem */
  --mobile-pad-bottom: .5rem;      /* a little extra below each item */
  --mobile-last-extra-bottom: .2rem;
        }

        .sf-header{ position:relative; }

        /* desktop: keep existing layout with responsive spacing */
        .main-nav{
          display:flex; align-items:center; flex-wrap:wrap;
          gap: clamp(10px, 2.2vw, 22px);
        }

        /* gold dots between items (desktop only) */
        .main-nav > * + *{ position:relative; }
        .main-nav > * + *::before{
          content:"";
          display:inline-block; width:6px; height:6px; border-radius:50%;
          background:var(--sf-gold);
          vertical-align:middle;
          margin: 0 clamp(10px, 1.6vw, 18px) 0 clamp(4px, .6vw, 8px);
        }

        .main-nav a, .main-nav button{
          background:transparent; border:none;
          color:inherit; text-decoration:none; font:inherit; cursor:pointer;
          padding:0; /* rely on gap + dots for spacing */
        }

        .nav-logout{ color:#fff; }

        /* hamburger: hidden on desktop */
        .sf-hamburger-toggle{
          display:none; /* show in mobile only */
          position:absolute;
          top: var(--burger-top);
          right: var(--burger-right);
          background:transparent; border:none; padding:6px; cursor:pointer;
          z-index:1002;
        }
        .sf-hamburger-bar{
          display:block; width:26px; height:3px; border-radius:3px;
           background:#fdca05; 
          margin:5px 0;
          box-shadow:0 0 10px var(--sf-gold-20);
        }
          .social-links a {
  color: #fdca05;
  text-decoration: none;
}

        /* default: mobile-only items hidden */
        .mobile-coffee-link{ display:none; }

/* MOBILE */
@media (max-width: 725px){
  .sf-hamburger-toggle{ display:block; }
  .buy-coffee{ display:none; }
  .mobile-coffee-link{ display:block; }

  .main-nav{
    position:absolute; left:0; right:0; top:74%;
    background:rgba(0,0,0,.96);
    box-shadow:0 10px 24px rgba(0,0,0,.5);
    display:flex;
    flex-direction:column;
    align-items:stretch;
    gap: var(--mobile-item-gap);           /* primary control for gaps */
    padding:0; margin:0;
    max-height:0; overflow:hidden; transition:max-height .28s ease;
    z-index:1001;
  }

  .main-nav.open{ max-height:70vh; padding:.25rem 0; }

  /* OVERRIDE the desktop reset with equal/higher specificity */
  .main-nav a,
  .main-nav button{
    display:block;                         /* make full-width rows */
    width:100%;
    text-align:center;
    padding: var(--mobile-pad-top) 0 var(--mobile-pad-bottom);
    border-top:1px solid rgba(255,255,255,.08);
  }
  .main-nav > *:first-child{ border-top:none; }

  /* Remove desktop dots in mobile */
  .main-nav > * + *::before{ display:none; }

  /* Extra breathing room at very bottom */
  .main-nav > *:last-child{
    padding-bottom: calc(var(--mobile-pad-bottom) + var(--mobile-last-extra-bottom));
  }

  .mobile-coffee-link{
    font-weight:800; letter-spacing:.5px;
  }

  /* HARD GUARANTEE: margin gap in case flex-gap is ignored anywhere */
  .main-nav > * + *{ margin-top: var(--mobile-item-gap); }
}

/* Dropdown container */
.sf-dropdown{ position:relative; display:flex; align-items:center; }

/* Button + caret */
.sf-dropdown-btn{
  background:transparent; border:none; color:inherit; font:inherit; cursor:pointer;
  display:flex; align-items:center; gap:.35rem; padding:0;
}
.sf-caret{
  display:inline-block; width:0; height:0;
  border-left:5px solid transparent; border-right:5px solid transparent;
  border-top:6px solid currentColor; transition:transform .2s ease;
}
.sf-caret.up{ transform:rotate(180deg); }

/* Panel (desktop) */
.sf-dropdown-menu{
  position:absolute; top:115%; left:0; min-width:220px;
  background:#0b0611; border:1px solid rgba(255,255,255,.12);
  border-radius:10px; padding:.4rem 0; list-style:none;
  box-shadow:0 10px 24px rgba(0,0,0,.45);
  opacity:0; pointer-events:none; transform:translateY(-4px);
  transition:opacity .18s ease, transform .18s ease;
  z-index:1003;
}
.sf-dropdown-menu.open{ opacity:1; pointer-events:auto; transform:translateY(0); }
.sf-dropdown-link{
  width:100%; text-align:left; padding:.55rem .9rem;
  background:transparent; border:none; cursor:pointer;
  color:rgba(255,255,255,.9); font-weight:600;
}
.sf-dropdown-link:hover{ background:rgba(255,255,255,.06); color:#fff; }

/* MOBILE behavior: make the dropdown inline and stacked with the menu */
@media (max-width: 725px){
  .sf-dropdown{ width:100%; flex-direction:column; align-items:stretch; }

  .sf-dropdown-btn{
    width:100%; text-align:center;
    padding: var(--mobile-pad-top) 0 var(--mobile-pad-bottom);
    border-top:1px solid rgba(255,255,255,.08);
  }

  .sf-dropdown-menu{
    position:static; min-width:unset; margin-top:.15rem;
    background:transparent; border:none; border-radius:0; box-shadow:none;
    padding:0;
    opacity:1; pointer-events:auto; transform:none;
    display:none;
  }
  .sf-dropdown-menu.open{ display:block; }

  .sf-dropdown-link{
    padding:.5rem 0;
    text-align:center;
    border-top:1px dashed rgba(255,255,255,.12);
  }
  .sf-dropdown-link:first-child{ border-top:none; }
}

.sf-dropdown-link{
  width:100%;
  text-align:left;
  padding:.75rem 1rem;                 /* a bit more vertical space */
  background:transparent;
  border:none;
  cursor:pointer;
  color:rgba(255,255,255,.9);
  font-weight:600;
  display:flex;                        /* enable dot + label */
  align-items:center;
  gap:.6rem;
}
.sf-dropdown-link::before{
  content:"";
  display:inline-block;
  width:7px; height:7px;               /* gold dot */
  border-radius:50%;
  background:var(--sf-gold);
  box-shadow:0 0 6px var(--sf-gold-20);
  flex:0 0 7px;
}

@media (max-width: 725px){
  .sf-dropdown-link{
    padding:.7rem 0;                                   /* more vertical space on mobile */
    text-align:center;
    border-top:1px dashed rgba(255,255,255,.12);
    display:flex;                                      /* center dot + label */
    justify-content:center;
    align-items:center;
    gap:.55rem;
  }
  .sf-dropdown-link:first-child{ border-top:none; }
}

.sf-dropdown-menu li + li{ margin-top:.3rem; }





.main-nav a, .main-nav button{
  background:transparent; border:none;
  color:inherit; text-decoration:none; font:inherit; cursor:pointer;
  padding:0;
  transition: color .15s ease;
}

/* Hover gold for main links and dropdown button items */
.main-nav a:hover,
.main-nav button:hover,
.sf-dropdown-link:hover,
.sf-dropdown-btn:hover{
  color: var(--sf-gold);
}

/* Active page = gold (NavLink adds .active automatically) */
.sf-nav-link.active{
  color: var(--sf-gold);
}

/* Keep dropdown row hover background if you like, but make text gold */
.sf-dropdown-link:hover{
  background:rgba(255,255,255,.06);
}

/* Mobile: give the gold dot a bit more breathing room next to the title */
@media (max-width: 725px){
  .sf-dropdown-link{
    gap:.85rem;
  }
}




@media (max-width: 725px){
  .sf-dropdown-link{
    padding:.7rem 0;
    text-align:center;
    border-top:1px dashed rgba(255,255,255,.12);
    display:flex;
    justify-content:flex-start;
    align-items:flex-start;
    gap:1.1rem;        /* increase space between gold dot and text */
  }
  .sf-dropdown-link:first-child{ border-top:none; }
}



@media (max-width: 725px){
  .sf-dropdown-link::before{
    margin-right:.3rem;  /* tiny extra cushion next to the label */
  }
}






      `}</style>
    </header>
  );
};

export default React.memo(Header);
